export const CANCELLATION_SUFFIX = " cancellation";

export const CANCELLABLE_ACTION_LABELS = new Set([
  "Regularise checks",
  "On Duty",
  "Change WO",
  "Restricted Holiday",
  "Overtime",
  "Comp Off",
  "Comp Off Work",
  "Change Shift",
  "Short Leave",
]);

export function parentActionLabel(actionLabel) {
  const raw = String(actionLabel || "").trim();
  if (raw.endsWith(CANCELLATION_SUFFIX)) {
    return raw.slice(0, -CANCELLATION_SUFFIX.length);
  }
  return raw;
}

export function cancellationActionLabel(actionLabel) {
  return `${parentActionLabel(actionLabel)}${CANCELLATION_SUFFIX}`;
}

export function isCancellationActionLabel(actionLabel) {
  return String(actionLabel || "").trim().endsWith(CANCELLATION_SUFFIX);
}

export function isCancellableActionLabel(actionLabel) {
  const parent = parentActionLabel(actionLabel);
  if (parent === "Comp Off Credit") return false;
  return CANCELLABLE_ACTION_LABELS.has(parent);
}

export function isDeskCancellationRequest(request) {
  if (!request) return false;
  if (String(request.requestType || "").toLowerCase() === "cancellation") return true;
  return isCancellationActionLabel(request.actionLabel);
}

export function canShowRequestCancellation(request) {
  if (!request || request.status !== "Approved") return false;
  if (request.cancelledAfterApproval) return false;
  if (String(request.linkedCancellation?.status || "").toLowerCase() === "approved") {
    return false;
  }
  if (parentActionLabel(request.actionLabel) === "Comp Off Credit") return false;
  if (isDeskCancellationRequest(request)) return false;
  return request.canRequestCancellation === true;
}

export function hideCancelledParentsWhenChildPresent(items = []) {
  const completedParentIds = new Set();
  const completedParentRequestIds = new Set();
  for (const item of items) {
    if (!isDeskCancellationRequest(item)) continue;
    if (item.status !== "Approved" && item.status !== "Cancelled") continue;
    const pid = Number(item.parentQuickRequestId);
    if (Number.isFinite(pid) && pid > 0) completedParentIds.add(pid);
    const pref = String(item.formData?.parentRequestId || "").trim();
    if (pref) completedParentRequestIds.add(pref);
  }
  if (!completedParentIds.size && !completedParentRequestIds.size) return items;
  return items.filter((item) => {
    if (!item.cancelledAfterApproval) return true;
    const sid = Number(item.serverDeskId || item.id);
    if (Number.isFinite(sid) && completedParentIds.has(sid)) return false;
    if (completedParentRequestIds.has(String(item.requestId))) return false;
    return true;
  });
}

export const CANCELLATION_ACTION_LABELS = Array.from(CANCELLABLE_ACTION_LABELS).map(
  (label) => cancellationActionLabel(label)
);
